import Vue from "vue";
export const sum = (v) => `${v || 0}`.replace(/\B(?=(\d{3})+(?!\d))/g, " ");

Vue.prototype.$sum = sum;

Vue.filter("sum", sum);
